/**
 * Kun appserver-flag. Ingen klient-længde-tjek — ellers kan ny ClientApp
 * tvinge skift mod gammel appserver uden teknikerskiftpwd (ClientApp-først).
 */
export function resolveSkalSkifteKodeord(
    bruger: { skalSkifteKodeord?: boolean; SkalSkifteKodeord?: boolean } | null | undefined
): boolean {
    return bruger?.skalSkifteKodeord === true || bruger?.SkalSkifteKodeord === true;
}
